import { Pipe, PipeTransform } from 'angular-ts-decorators';

import { SettingsManager } from '../services/settings-manager';

export type SwCurrencyFilter = (input: string, fractionSize?: number) => string;

interface ISwCurrency {
  transform: SwCurrencyFilter;
}

/**
 * Filters the number (input) into the money value with currency symbol matching
 * the currencySymbol from settings. With franctionSize number of digits behind
 * the decimal. The currency codes from settings should edhere
 * to ISO standards, see https://en.wikipedia.org/wiki/ISO_4217
 * @param {String} input
 * @param {Integer} fractionSize
 * @param {String} currencySymbol
 * @return {String} currencySymbol_plus_formatted_amount
 */
@Pipe({ name: 'swCurrency' })
export class SwCurrencyPipe implements PipeTransform, ISwCurrency {
  constructor(
    private numberFilter,
    private settingsManager: SettingsManager,
  ) {
    'ngInject';
  }

  public transform(input: string, fractionSize?: number): string {
    let currencySymbol = this.settingsManager.settings.currency;

    if (angular.isUndefined(fractionSize)) {
      fractionSize = 2;
    }

    switch (currencySymbol) {
      case 'EUR':
        currencySymbol = '€';
        break;
      case 'USD':
        currencySymbol = '$';
        break;
      case 'GBP':
        currencySymbol = '£';
        break;
      case 'TRY':
        currencySymbol = '₺';
        break;
      case 'MAD':
        currencySymbol = 'Dhs';
        break;
      case 'BRL':
        currencySymbol = 'R$';
        break;
      case undefined:
        currencySymbol = '€';
        break;
    }

    if (angular.isUndefined(input) || input === null) {
      return currencySymbol + '\u00A0';
    } else {
      return currencySymbol + '\u00A0' + this.numberFilter(input, fractionSize);
    }
  }
}
